module.exports = __webpack_public_path__ + "media/images/pen_dimgrey-998da557.png";